import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { OfferKind } from '@recruitee/http-types';
import { createEffectFactory } from '@recruitee/ngrx';

import { TalentPoolsNewBriefActions } from './talent-pool-brief.store';
import { TalentPoolsHttpClient } from './talent-pool.http-client';

@Injectable({ providedIn: 'root' })
export class TalentPoolsBriefEffects {
  public effects = createEffectFactory(TalentPoolsNewBriefActions, this.actions$);

  public fetchCollection$ = this.effects(
    TalentPoolsNewBriefActions.fetchCollection,
    action =>
      this.http.fetchCollectionBrief().pipe(
        map(response => ({
          data: response.talentPools.map(item => ({
            ...item,
            kind: OfferKind.TalentPool,
          })),
        })),
      ),
    { customMapOperator: mergeMap },
  );

  constructor(
    private actions$: Actions,
    private http: TalentPoolsHttpClient,
  ) {}
}
